<script>
import { mapActions } from 'vuex';
import ItemModal from './ItemModal';
import TableView from '@/components/elements/views/TableView';

export default {
    components: {
        ItemModal
    },

    extends: TableView,

    props: {
        formId: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            includeHeader: false,
            includeDeleteAction: false,
            selectedSubmission: null
        };
    },

    computed: {
        additionalFetchData() {
            return {
                id: this.formId
            };
        },

        options() {
            return {
                addButton: false,
                searchInput: false
            };
        },

        labels() {
            return [
                {
                    value: 'user.fullName',
                    width: '300px',
                    sortFieldName: 'user.firstName'
                },
                {
                    value: 'createdAt',
                    type: 'date',
                    filter: 'formatDate',
                    width: '150px'
                }
            ];
        },

        additionalComponents() {
            if (!this.selectedSubmission) {
                return [];
            }

            return [
                {
                    name: 'item-modal',
                    props: {
                        submission: this.selectedSubmission
                    }
                }
            ];
        }
    },

    methods: {
        ...mapActions({
            getItems: 'forms/getSubmissions'
        }),

        async onRowClick(item) {
            this.selectedSubmission = { ...item };

            await this.$nextTick();

            this.$bvModal.show('submission-item-modal');
        }
    }
};
</script>
